import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { api } from '../../lib/api'
import { useI18n } from '../../lib/i18n'

export interface ShowcaseExample {
  slug: string
  venueName: string
  publicTitle: string
  city: string
  coverUrl: string | null
  accentColor: string
  typographyPack: string
  template: 'catalogue' | 'portfolio' | 'wellness'
  url: string
}

export function usePublicShowcase() {
  return useQuery({
    queryKey: ['public-showcase'],
    queryFn: () => api<{ examples: ShowcaseExample[] }>('/api/public/showcase'),
    staleTime: 60_000,
    retry: 1,
  })
}

// A catalogue entry proves this exact target exists; it does not prove that
// bookings are fictional or free. Never substitute another merchant's slug.
export function BookingExampleLink({ slug, className, fallback = 'pilot' }: {
  slug: string
  className?: string
  fallback?: 'pilot' | 'preview'
}) {
  const { locale, l, isRtl } = useI18n()
  const showcase = usePublicShowcase()
  const Arrow = isRtl ? ArrowLeft : ArrowRight
  const available = showcase.isSuccess && showcase.data.examples.some((example) => example.slug === slug)
  return available
    ? <Link to="/book/$slug" params={{ slug }} search={{ lang: locale }} className={className}>
      {l('Buchungsseite ansehen', 'View booking page', 'عرض صفحة الحجز', 'Boekingspagina bekijken')} <Arrow size={17} aria-hidden="true" />
    </Link>
    : <a href={fallback === 'preview' ? '#product' : `/?lang=${locale}#pilot`} className={className}>
      {fallback === 'preview'
        ? l('So funktioniert es', 'See how it works', 'طريقة العمل', 'Bekijk hoe het werkt')
        : l('Pilot-Einrichtung anfragen', 'Request pilot setup', 'طلب إعداد التجربة', 'Pilot aanvragen')} <Arrow size={17} aria-hidden="true" />
    </a>
}
